import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import Sidebar from "./Sidebar";
// import { data } from "../common/constant";
import PropertyTile from "./common/PropertyTile";
import http from "../api/server";
import { GET_CLINET_ID_API, PROPERTY_DASHBOARD_API } from "../api/apiPath";
import { Link, useNavigate,  generatePath, useParams } from "react-router-dom";
import LoadingComponent from "./common/LoadingComponent";
import SidebarIcons from "./SidebarIcons";
import { UserRoles } from "./common/constant";

import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import IconButton from "@mui/material/IconButton";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
// import Icon from "react-multi-date-picker/components/icon";

const CustomIcon = (props) => {
  return (
    <IconButton onClick={props.openCalendar}>
      <FilterListIcon sx={{ color: "#EF3800" }} />
    </IconButton>
  );
};

const PropertyForm = () => {
  const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const [propertyData, setPropertyData] = useState(null);
  // const [data, setPageData] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userObj } = useSelector((state) => state.user);
  const [userRole, setUserRole] = useState(null);
  const [inspectorTileInfo, setinspectorTileInfo] = useState(null);
  const [adminInspectionInfo, setadminInspectionInfo] = useState(null);
  const [adminDashboardInfo, setAdminDashboardInfo] = useState(null);
  const [dashboardTiles, setDashboardTiles] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [selectedTile, setSelectedTile] = useState(null);

  const navigate = useNavigate();
  const openScanner = () => {
    navigate(
      generatePath("/client/:clientNameParam/scanDoor", {
        clientNameParam,
      })
    );
  };

  useEffect(() => {
    if (data?.propertyFields) {
      const tempfilteredRows = data?.propertyFields?.filter((item) => {
        const matchesSearch =
          !searchText ||
          item.propertyName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.blockName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.propertyLocation
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.cityName?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.inspectionReferenceNumber
            ?.toLowerCase()
            .includes(searchText.toLowerCase()) ||
          item.status?.toLowerCase().includes(searchText.toLowerCase()) ||
          item.inspectedBy?.toLowerCase().includes(searchText.toLowerCase());

        // const matchesPropertyName =
        //   toolbar.propertyName === "Property Name" ||
        //   row.propertyName.toLowerCase() === toolbar.propertyName.toLowerCase();

        // const matchesInspector =
        //   toolbar.inspector === "Inspector" ||
        //   row.inspector
        //     ?.toLowerCase()
        //     .includes(toolbar.inspector.toLowerCase());

        const matchesStatus =
          statusFilter === "All" || item.status === statusFilter;
        const rawdate =
          item.scheduledInspectionDate != null
            ? new Date(item.scheduledInspectionDate).toLocaleDateString("en-GB")
            : null;
        const [day, month, year] =
          rawdate != null
            ? rawdate.split("/")
            : [null, null, null];
        const rowDate =
          rawdate != null
            ? stripTime(`${year}-${month}-${day}`)
            : null;
        const [start, end] = dateRange;

        const matchesDate =
          start === null ||
          end === null ||
          ((!start || rowDate >= stripTime(start)) &&
            (!end || rowDate <= stripTime(end)));

        return (
          matchesSearch &&
          // matchesPropertyName &&
          // matchesInspector &&
          matchesStatus &&
          matchesDate
        );
      });
      setFilteredRows(tempfilteredRows);
    } else {
      setFilteredRows(data?.propertyFields);
    }
  }, [data?.propertyFields, searchText, dateRange, statusFilter]);
  const stripTime = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  // const getSearchData = (value) => {
  //   const filteredResults = data?.propertyFields?.filter(
  //     (item) =>
  //       item.propertyName?.toLowerCase().includes(value.toLowerCase()) ||
  //       item.blockName?.toLowerCase().includes(value.toLowerCase()) ||
  //       item.propertyLocation?.toLowerCase().includes(value.toLowerCase()) ||
  //       item.cityName?.toLowerCase().includes(value.toLowerCase()) ||
  //       item.inspectionReferenceNumber
  //         ?.toLowerCase()
  //         .includes(value.toLowerCase()) ||
  //       item.status?.toLowerCase().includes(value.toLowerCase()) ||
  //       item.inspectedBy?.toLowerCase().includes(value.toLowerCase())
  //   );
  //   setPropertyData(filteredResults);
  // };

  useEffect(() => {
    if (userObj) {
      const fetchData = async () => {
        try {
          const responseClient = await http.get(
            GET_CLINET_ID_API + "/" + userObj?.userId
          );
          setUserRole(responseClient?.data?.roleId);
          const response = await http.get(
            PROPERTY_DASHBOARD_API +
              "clientId=" +
              responseClient?.data?.clientId +
              "&userId=" +
              userObj.userId
          );
          if (!response.status) {
            throw new Error(`HTTP error! status: ${response?.message}`);
          }
          const result = await response?.data;
          setData(result);
          setPropertyData(result?.propertyFields);
          setadminInspectionInfo(result?.adminApproverTotalInspections);
          setinspectorTileInfo(result?.inspectorsTotalInspections);
          setAdminDashboardInfo(result?.adminDashboardInfos);

          const tempDashboardTiles = [];
          if (responseClient?.data?.roleId === UserRoles.INSPECTOR) {
            if (result?.inspectorsTotalInspections !== null) {
              tempDashboardTiles.push(
                {
                  title: "Total Inspections Assigned",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionAssigned || 0,
                  icon: "bi bi-door-closed",
                  statusText: "All",
                },
                {
                  title: "Total Doors Surveyed",
                  count:
                    result?.inspectorsTotalInspections?.totalDoorSurveyed || 0,
                  icon: "bi bi-check-circle text-success",
                  statusText: "All",
                },
                {
                  title: "Total Inspections In Progress",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionsInProgress || 0,
                  icon: "bi bi-x-circle text-warning",
                  statusText: "In Progress",
                },
                {
                  title: "Total Inspections Approved",
                  count:
                    result?.inspectorsTotalInspections
                      ?.totalInspectionApproved || 0,
                  icon: "bi bi-exclamation-triangle text-danger",
                  statusText: "Approved",
                }
              );
            }
          } else if (
            responseClient?.data?.roleId === UserRoles.APPROVER ||
            responseClient?.data?.roleId === UserRoles.ADMIN
          ) {
            if (result?.adminApproverTotalInspections !== null) {
              tempDashboardTiles.push(
                {
                  title: "Total Inspections",
                  count:
                    result?.adminApproverTotalInspections?.totalInspections ||
                    0,
                  icon: "bi bi-door-closed",
                  statusText: "All",
                },
                {
                  title: "Total Approved Inspections",
                  count:
                    result?.adminApproverTotalInspections
                      ?.totalApprovedInspection || 0,
                  icon: "bi bi-check-circle text-success",
                  statusText: "Approved",
                },
                {
                  title: "Total Inspections Under Review",
                  count:
                    result?.adminApproverTotalInspections
                      ?.totalInspectionUnderReview || 0,
                  icon: "bi bi-x-circle text-warning",
                  statusText: "Under Review",
                },
                {
                  title: "Total Inspections Rejected",
                  count:
                    result?.adminApproverTotalInspections
                      ?.totalRejectedInspection || 0,
                  icon: "bi bi-exclamation-triangle text-danger",
                  statusText: "Rejected",
                }
              );
            }
          }

          setDashboardTiles(tempDashboardTiles);
        } catch (err) {
          setError(err?.data);
        } finally {
          setLoading(false);
        }
      };
      console.log(inspectorTileInfo, adminDashboardInfo, adminInspectionInfo);
      fetchData();
    }
  }, [userObj]);
  // if (loading) return <p>Loading...</p>;
  if (error)
    return (
      <>
        <div className="inCenterDiv">
          <i className="bi bi-exclamation-triangle red"></i>
          <h3>Something went wrong!</h3>
          <p>{error?.message}</p>
          <div className="col-sm-12 mb-4 text-center">
            <Link to={generatePath("/client/:clientNameParam/", {
                                clientNameParam,
                              })}>Go back to Login</Link>
          </div>
        </div>
      </>
    );
  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          {/* <div className="d-flex dashboard_body flex-column py-3 w-100"> */}
          <div className="d-flex dashboard_body flex-column py-3 w-100">
            <div className="row m-0 ">
              <div
                className="col-sm-12 d-flex justify-content-end"
                style={{
                  paddingTop: "10px",
                  paddinBottom: "14px",
                  marginBottom: "14px",
                }}
              >
                <button
                  type="button"
                  className="btn btn-primary py-2 px-4"
                  onClick={openScanner}
                  style={{ borderRadius: "8px" }}
                >
                  <i className="fa fa-solid fa-qrcode me-2"></i>Scan Door
                </button>
              </div>
            </div>
            {/* {loading ? (
              <div className="spinloader"></div>
            ) : ( */}
            <>
              <div className="row m-0">
                {dashboardTiles &&
                  dashboardTiles?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="col-6 col-sm-6 col-lg-3 col-md-3 mb-3"
                        onClick={() => {
                          setSelectedTile(index);
                          setStatusFilter(item?.statusText);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className={
                            selectedTile === index
                              ? "card text-bg-primary bulid_card_selected"
                              : "card text-bg-primary bulid_card"
                          }
                        >
                          <div className="card-body text-center d-flex flex-column gap-2">
                            <i className={item?.icon}></i>
                            <strong className="fs-5">{item?.count || 0}</strong>
                            <small>{item?.title}</small>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="row m-0 flex-row justify-content-between">
                <div className="search_bar pb-3" style={{ width: "90%" }}>
                  <i className="fa-solid fa-magnifying-glass"></i>
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInput"
                    placeholder="Search properties"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "auto",
                    paddingRight: "10px",
                    paddingLeft: "0px",
                  }}
                >
                  <DatePicker
                    range
                    value={dateRange}
                    onChange={(range) => setDateRange(range || [null, null])}
                    format="YYYY-MM-DD"
                    type="custom"
                    render={<CustomIcon />}
                    plugins={[
                      <Toolbar
                        key={1}
                        position="bottom"
                        sort={["deselect", "close", "today"]}
                      />,
                    ]}
                  />
                </div>
                <div style={{ width: "auto", paddingLeft: "0px" }}>
                  <IconButton
                    tabIndex={0}
                    title="Clear Filters"
                    onClick={() => {
                      setSelectedTile(null);
                      setStatusFilter("All");
                      setSearchText("");
                      setDateRange([null, null]);
                    }}
                  >
                    <ClearIcon sx={{ color: "#EF3800" }} fontSize="small" />
                  </IconButton>
                </div>
              </div>
              {propertyData &&
                filteredRows?.map((item) => {
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <PropertyTile
                      data={item}
                      userRole={userRole}
                      // InspectionPropertyInfo={inspectionPropertyInfo}
                    />
                  );
                })}
            </>
            <LoadingComponent loading={loading} />
            {/* // )} */}
          </div>
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default PropertyForm;
